/**
 * Construct a resource url from the provided id and path
 *
 * @param {string} path the path to the resource, i.e. /vehicle-api/geofences
 * @param {id} resourceId the resource id
 *
 * @returns {string} the constructed url
 */
export default (path, resourceId) => {
  try {
    return new URL(`${path}/${resourceId}`, window.REACT_APP_VEHICLE_API_URL).toString();
  } catch (err) {
    console.error("Could not construct url from path {path} and id {resourceId} ");
    return "";
  }
};
